export default {
  title: 'Lisää luottokortti',
  buttons: {
    save: 'Tallenna',
  },
  feedback: {
    success: 'Kortti lisätty onnistuneesti',
  },
};
